import React from "react";
import { reduxForm } from "redux-form";

import CustomFields from "../../../../shared/components/custom-fields";
import { displayOnStep } from "../utils";

export class ThankYouForm extends React.Component {
  render() {
    const { handleSubmit, customFields } = this.props;

    return (
      <form data-testid="t-giving-form--ThankYo-form" onSubmit={handleSubmit}>
        <CustomFields checkStepNumber={displayOnStep} customFields={customFields} />
      </form>
    );
  }
}

export default reduxForm({
  form: "thank-you",
})(ThankYouForm);
